import { render } from "./passwordChange.vue?vue&type=template&id=472506a8&scoped=true"
import script from "./passwordChange.vue?vue&type=script&lang=js"
export * from "./passwordChange.vue?vue&type=script&lang=js"

import "./passwordChange.vue?vue&type=style&index=0&id=472506a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472506a8"]])

export default __exports__